import React, { useEffect, useMemo, useRef, useState } from 'react';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Facebook} from 'react-spinners-css';
import { useServices } from '../../hooks/useServices';
import { ElijePago } from '../elige/ElijePago';

import { useHistory } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import { Unefon1 } from './Unefon1';
import { RedUnefon1 } from '../redes/RedUnefon1';
import { UnefonFlex } from './UnefonFlex';
import { RedFlex } from '../redes/RedFlex';
import { ImportantDevicesTwoTone } from '@material-ui/icons';
import { UnefonIlimitado2 } from './UnefonIlimitado2';
import { Unefon2 } from './Unefon2';
import { RedUnefon2 } from '../redes/RedUnefon2';
import { RedIlimitado2 } from '../redes/RedIlimitado2';

export const OfertaListo2 = React.memo(({data1, lic}) => {

    const { activaSas, activaKairos, guardarDatosPay } = useServices();
 
   

    const [value, setValue] = useState('');
    
    const [oferta, setOferta] = useState({});
    const [ofertas, setOfertas] = useState([]);
    const [oferMain, setOfeMain] = useState(true);
    const [cargando, setCargando] = useState(false);
    const [licObjeto, setLicObjeto] = useState();


    const ref = useRef();
    const seleccionado = useRef(false);
    const history = useHistory();


    const redes = useRef();
    const legalTexto = useRef();
    const maximo = useRef();
    const alto = useRef(145);


    let reqLIC = {
        ...lic
    }

    

   const editLegal = () => {
        let tiene = false;
        let tiene1 = false;
        let textoLegal = data1.legal;
        //console.log('legal completo: ', textoLegal);
        const indice = textoLegal.indexOf('**');
        const indice1 = textoLegal.indexOf('*');
        
            data1.oferta.map((ofr)=>{
                        ofr.beneficiosOferta.map((of)=>{
                        	
                            if (of.benefitDescription.indexOf('**') > -1 || of.benefitQuantity.indexOf('**') > -1 )
                            { tiene = true;}
                            
                        });
                        ofr.beneficiosBase.map((of)=>{
                        	if (of.benefitDescription.indexOf('*') > -1 || of.benefitQuantity.indexOf('*') > -1)
                            { tiene1 = true;}
                          
                        });
                        
                    });
        
                    if (tiene == false && data1.planId !== 4){
                        textoLegal = textoLegal.slice(0, indice);
                    }
                    if (tiene1 == false){
                        textoLegal = textoLegal.slice(indice, -1);
                    }
                      
        const texto = textoLegal.replaceAll("|","\n");
        legalTexto.current =  `${texto}`;
   }
  
  

   const getLen = () => {
       let lens= [];
    data1.oferta.map((ofr)=>{
        lens = [...lens,ofr.beneficiosBase.length ]
    });
    const max = Math.max.apply(null, lens);
    if(max == 1){
        maximo.current= 2;
    }else{
        maximo.current= max;
    }
   
   }
   


    const handleRadioChange = (event) => {
        setValue(event.target.value);
        seleccionado.current = true;

        window.scrollTo(0, document.body.scrollHeight);
        data1.oferta.map((ofr)=>{
            if(ofr.topupAmount === event.target.value) {
                ofr.dn = data1.dn;
                setOferta({...ofr});
            }
        });
      };

//    planId :
// 1 - unefon ilimitado 1
// 2 - unefon ilimitado 2
// 3 - unefon 2
// 4 - unefon flex

    
    const tipoOferta = (ofertaParam) => {
        darEspacios(ofertaParam);
        quitarEspacios(ofertaParam);
        switch (data1.planId) {
            case 1:
                return <Unefon1  oferta1={ofertaParam}/>
            break;
            case 2:
                return <UnefonIlimitado2  oferta1={ofertaParam}/>
            break;
            case 3:
                return <Unefon2  oferta1={ofertaParam}/>
            break;
            case 4:
                return <UnefonFlex  oferta1={ofertaParam}/>
            break;
            default:
                console.log('no existe planId');
                break;
        }
    }

    const altosRedes = (ofertaParam) => {
        switch (data1.planId) {
            case 1:
                redes.current = <RedUnefon1/>
            break;
            case 2:
                alto.current = 130;
                redes.current = <RedIlimitado2/>
            break;
            case 3:
                alto.current = 145;
                redes.current = <RedUnefon2/>
            break;
            case 4:
                redes.current = <RedFlex/>
            break;
            default:
                console.log('no existe planId');
                break;
        }
    }

    const quitarEspacios = (oferta) =>{
        oferta.beneficiosBase.map((of)=>{
            of.benefitDescription = of.benefitDescription.replace(/\s*(.*?)\s*\*/g,'$1*');
        });
    }
    
   

    const darEspacios = (oferta) =>{
        oferta.beneficiosBase.map((of)=>{
            of.topupAmount = oferta.topupAmount;
            //le quito las comas que vienen entre dos digitos
            of.benefitQuantity = of.benefitQuantity.replace(/(\d),(?=\d)/g,'$1');
            //sustituyo las comas por coma y un espacio
           of.benefitQuantity = of.benefitQuantity.split(',').join(', ');
        });
    }

    const ordenarOfertas = () => {
        let promos = [];
        return new Promise((resolve,reject)=>{
           data1.oferta.map((ofr)=>{
            promos = [...promos, ofr.topupAmount];
            promos.sort(function(a, b){return a-b});
                ofr.beneficiosBase.map((of)=>{
                    ofr.validity = of.validity;
                });
            });
            ref.current = promos
            resolve();
        });
       
    }

    const ordenarOfertas2 = async() => {
        let promos = [];
        await ordenarOfertas();
        
        data1.oferta.map((ofr)=>{
            
            promos = [ofr,...promos];   
        });
        promos.sort(function (a, b) {
			return a.topupAmount - b.topupAmount;
		  });
        setOfertas(promos);
        console.log('ofertas: ', promos);
      
    }

   

	async function seleccionaOferta() {
       
		if (oferta.dn) {
			seleccionado.current = true;
			if (data1.crm === "SAS") {
				const sas = {
					"mdn": data1.dn,
					"tksId": oferta.tskId,
					"redeemedTime": moment().format()
				}
				//console.log('oferta a activar sas: ', sas);
				setOfeMain(false);
				const respuestaActivacion = await activaSas(sas);
				
				if (respuestaActivacion) {
					if (respuestaActivacion.status) {
						//console.log('error activar SAS:', respuestaActivacion.status);
						history.push("/error");

					} else {
						//console.log('SAS: ', respuestaActivacion);

						if (respuestaActivacion.code == 0) {
							localStorage.setItem('oa', oferta.tskId);
							setCargando(true);
						
							guardaDataPay();
						} else {
							//console.log('error activar SAS:', respuestaActivacion);
							history.push("/error");
						}
					}

				} else {
					//console.log('error activar SAS 2: ', respuestaActivacion);
					history.push("/error");
				}
			} else {
				const kairos = {
					"mdn": data1.dn,
					"tksId": oferta.tskId,
					"diasVigencia": data1.diasVigencia,
					"redeemedTime": moment().format()
				}
				//console.log('oferta a activar kairos: ', kairos);
				setOfeMain(false);
				const respuestaActivacion = await activaKairos(kairos);

				if (respuestaActivacion) {
					if (respuestaActivacion.status) {
						//console.log('error activar Kairos:', respuestaActivacion.status);
						history.push("/error");

					} else {
						//console.log('Kairos: ', respuestaActivacion);

						if (respuestaActivacion.code == 0) {
							localStorage.setItem('oa', oferta.tskId);
							setCargando(true);
						
							guardaDataPay();
						} else {
							//console.log('error activar Kairos:', respuestaActivacion);
							history.push("/error");
						}
					}
				} else {
					//console.log('error activar Kairos 2: ', respuestaActivacion);
					history.push("/error");
				}
			}
		} else {
			seleccionado.current = false;
           
		}

	}

    async function guardaDataPay(){
    	const cantidad =  oferta.topupAmount;
        const numero = data1.dn;
        const payloadBit = {
            "mdn" : numero,
            "tskId" : oferta.tskId,
            "topupAmount":Number(cantidad),
            "redeemedTime": moment().format()
        }

        //console.log('guardamos oferta: ', payloadBit);
        
        
        const respuestaBitacora = await guardarDatosPay(payloadBit);
        //console.log('Response guardar bitacora:', respuestaBitacora);
        if (respuestaBitacora) {
            const trans_id = respuestaBitacora.transaction_id;
            if(respuestaBitacora.status){
                //console.log('error guardar bitacora:', respuestaBitacora);
                reqLIC = {
                    ...lic,
                    "dn":Number(numero),
                    "transactionExtId":trans_id + "",
                    "chargeAmount":Number(cantidad),
                }
            reqLIC.paymentDetail[0].amount = Number(cantidad);
                    setLicObjeto(reqLIC);
            }else{
                reqLIC = {
                    ...lic,
                    "dn":Number(numero),
                    "transactionExtId":trans_id + "",
                    "chargeAmount":Number(cantidad),
                }
                reqLIC.paymentDetail[0].amount = Number(cantidad);
                    setLicObjeto(reqLIC);
                    
            }
          }else{
            //console.log('error guarda: ', respuestaBitacora);
          }
        
    }


    let fechaVigencia = data1.fechaVigencia;
    fechaVigencia = moment(fechaVigencia).locale('es').format('LL');


   
    useEffect(() => {
        altosRedes();
        ordenarOfertas2();
        editLegal();
        getLen();
    }, [])

    return (
        <div>
            {
                oferMain === true
                ?<div>
                   
                    <div className="promo promoActiva">
                            
                            <div className="titulo">Selecciona tu oferta y presiona el botón Activar oferta</div>
                    
                            <p>Vigencia al {fechaVigencia}</p>
                    
                            <FormControl component="fieldset" className="contenedorFormas animate__animated animate__fadeIn" >
                            <RadioGroup row className="contenedorUnefon" value={value}  onChange={handleRadioChange}>
                            {
                                    ofertas.map( (offer, i) => (

                                        
                                        <div className={data1.oferta.length ==1 ? "ofertaM1" : "ofertaM"} key={ i } style={{height : maximo.current * alto.current +"px"}} >
                                            {
                                                (i === 0)
                                                && <div className="diagonalBox">
                                                    <div className="labelDestacado">Recarga recomendada</div>
                                                </div>
                                            }
                                            <FormControlLabel className="checkCustom" labelPlacement="bottom"  value={offer.topupAmount} control={<Radio color="primary"/>}  />
                                            <div className="cantidadOferta">${offer.topupAmount}</div>
                                            { 
                                            data1.planId === 3 
                                                &&<>
                                                <div className='diasvigencia'>/{offer.validity}</div>
                                                </>
                                            }
                                            { 
                                            data1.planId === 4 
                                                &&<>
                                                <div className='diasvigencia'>/{offer.validity}</div>
                                                </>
                                            }
                                            {tipoOferta(offer)}
                                        </div>
                                        
                                        )
                                    )
                                }
                            </RadioGroup>
                        </FormControl>
                            
                    </div>
                  
                    <div className="conteRedes">
                                {redes.current}
                    </div>

                    <div className={seleccionado.current === true? "btn":"btnFalse"} onClick={seleccionaOferta}>Activar oferta</div>
                    
                    <div className="textoRedes">
                    {legalTexto.current}
                    <div>Consulta coberturas, términos y condiciones de la oferta en unefon.com.mx</div>
                    </div>
                </div> 

                :  cargando === false ? <div className="spinner"><Facebook color="#594498"/></div> : <ElijePago cantidad={value} vigencia={fechaVigencia} lic1={licObjeto}/>
                
                
            }
               
        </div>
    )
})
